import type { ReactElement } from "react";
import type { MomentCardMoment } from "../../moment-card/types";
import { useMomentQueryFilterFunction } from "../hooks/use-client-filtered-moments";

export const FilterMoments = <T extends Omit<MomentCardMoment, "additional_recipients_json">>({
  moments,
  children,
}: {
  moments: T[];
  children: (filteredMoments: T[]) => ReactElement;
}): ReactElement => {
  const filteredMoments = useMomentQueryFilterFunction<T>()(moments);
  return children(filteredMoments);
};
